/** @jsx jsx */

import { useEffect } from 'react';

import type { executeAction as ExecuteActionType } from 'js/lib/executeActionType';

import { removeWidget as removeWidgetAction } from 'bundles/widget/actions/WidgetManagerActions';
import type { PropsToComponent } from 'bundles/widget/components/cds/WidgetFrame';
import type { WidgetState } from 'bundles/widget/reducers/WidgetManagerReducer';

export const useRemoveWidgetAction = (
  widgetId: PropsToComponent['widgetId'],
  removeListenerHandle: (() => void) | undefined,
  readyState: WidgetState['readyState'] | undefined,
  executeAction: ExecuteActionType
) => {
  useEffect(() => {
    return () => {
      if (widgetId && removeListenerHandle && readyState === 'ready') {
        executeAction?.(removeWidgetAction, {
          widgetId,
          removeListenerHandle,
        });
      }
    };
  }, [widgetId, removeListenerHandle, executeAction, readyState]);
};
